import script from "./ClientFieldsList.vue?vue&type=script&lang=ts&setup=true"
export * from "./ClientFieldsList.vue?vue&type=script&lang=ts&setup=true"

import "./ClientFieldsList.vue?vue&type=style&index=0&id=a7a4247a&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a7a4247a"]])

export default __exports__